var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4427 16.8393C20.8794 13.4501 18.2138 9.90577 16.3466 7.87725C15.8176 7.30255 15.063 7.00391 14.2819 7.00391H10.7181C9.93699 7.00391 9.18241 7.30255 8.65342 7.87724C6.78619 9.90575 4.12059 13.4501 3.55727 16.8393C3.06893 19.7773 5.77927 22.0039 8.80832 22.0039H16.1917C19.2207 22.0039 21.9311 19.7773 21.4427 16.8393Z",
    stroke: "#76B72A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58607 6.99999L7.5 3.5L9.48473 3.83079C10.1218 3.93697 10.771 3.72894 11.2277 3.27224L12.5 2L13.7723 3.27224C14.229 3.72894 14.8782 3.93697 15.5153 3.83079L17.5 3.5L15.4139 6.99999",
    stroke: "#76B72A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSack);
export default __webpack_public_path__ + "static/media/ic-sack.1ac3db99427b12bf2a0eea50b6919986.svg";
export { ForwardRef as ReactComponent };